module.exports = __webpack_public_path__ + "img/car-crash.dc688250.svg";